import { render, staticRenderFns } from "./DialogEditClient.vue?vue&type=template&id=1431872c&scoped=true&"
import script from "./DialogEditClient.vue?vue&type=script&lang=js&"
export * from "./DialogEditClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1431872c",
  null
  
)

export default component.exports